import type { Distance, Margins } from "@pdfking/math"
import { ZERO_MARGINS } from "@pdfking/math/constants"

import { SECURITY_AREA_DEFAULT } from "#constants"
import type { ComponentSchema } from "#internal"

/**
 * The security margins of `component`'s pages, top, right, bottom, left of
 * the page. Python `grow_with_dimensions` sets `margins=grow.show_security
 * and margins or None` (generic.py:90): a grow that shows no security frame
 * keeps none.
 */
export const ComponentSecurity = (component: ComponentSchema): Margins<Distance> =>
  component.grow_kind.show_security
    ? (component.security_margins ?? SECURITY_AREA_DEFAULT)
    : ZERO_MARGINS
